export default __webpack_public_path__ + "static/media/CimmerianEndCentralMap.0782917b.jpg";